import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.FranchiseeAppIndex.';
  public static readonly supplier = `${Id.prefix}supplier`;
  public static readonly macros = `${Id.prefix}macros`;
  public static readonly dbInstanceVersion = `${Id.prefix}dbInstanceVersion`;
  public static readonly dbPricingVersion = `${Id.prefix}dbPricingVersion`;
  public static readonly v6 = `${Id.prefix}v6`;
  public static readonly api = `${Id.prefix}api`;
  public static readonly location = `${Id.prefix}location`;
  public static readonly dealerBuild = `${Id.prefix}dealerBuild`;
  public static readonly frameConfig = `${Id.prefix}frameConfig`;
  public static readonly supplierDetails = `${Id.prefix}supplierDetails`;
  public static readonly copiedToClipboard = `${Id.prefix}copiedToClipboard`;
  public static readonly versionDetailsCopied = `${Id.prefix}versionDetailsCopied`;
  public static readonly build = `${Id.prefix}build`;
  public static readonly supplierSupportConnected = `${Id.prefix}supplierSupportConnected`;
  public static readonly testingConnection = `${Id.prefix}testingConnection`;
  public static readonly testingConnectionLastCheck = `${Id.prefix}testingConnectionLastCheck`;
  public static readonly branchPlural = `${Id.prefix}branchPlural`;
  public static readonly branchHidden = `${Id.prefix}branchHidden`;
  public static readonly restartV6Service = `${Id.prefix}restartV6Service`;
}

export class LangFranchiseeAppIndex {
  private constructor() {}
  public static supplier(): string {
    return interpolate(Id.supplier);
  }
  public static macros(): string {
    return interpolate(Id.macros);
  }
  public static dbInstanceVersion(): string {
    return interpolate(Id.dbInstanceVersion);
  }
  public static dbPricingVersion(): string {
    return interpolate(Id.dbPricingVersion);
  }
  public static v6(): string {
    return interpolate(Id.v6);
  }
  public static api(): string {
    return interpolate(Id.api);
  }
  public static location(): string {
    return interpolate(Id.location);
  }
  public static dealerBuild(): string {
    return interpolate(Id.dealerBuild);
  }
  public static frameConfig(): string {
    return interpolate(Id.frameConfig);
  }
  public static supplierDetails(): string {
    return interpolate(Id.supplierDetails);
  }
  public static copiedToClipboard(): string {
    return interpolate(Id.copiedToClipboard);
  }
  public static versionDetailsCopied(): string {
    return interpolate(Id.versionDetailsCopied);
  }
  public static build(): string {
    return interpolate(Id.build);
  }
  public static supplierSupportConnected(params: { tenantName: string }): string {
    return interpolate(Id.supplierSupportConnected, params);
  }
  public static testingConnection(): string {
    return interpolate(Id.testingConnection);
  }
  public static testingConnectionLastCheck(params: { time: string }): string {
    return interpolate(Id.testingConnectionLastCheck, params);
  }
  public static branchPlural(): string {
    return interpolate(Id.branchPlural);
  }
  public static branchHidden(): string {
    return interpolate(Id.branchHidden);
  }
  public static restartV6Service(params: { description: string }): string {
    return interpolate(Id.restartV6Service, params);
  }
}

export class FranchiseeAppIndexModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.supplier, "{{glossary 'supplier'}}", 'Label for supplier');
    register.add(Id.macros, 'Macros', 'Label for macros');
    register.add(Id.dbInstanceVersion, 'DB Instance Version', 'Label for DB instance version');
    register.add(Id.dbPricingVersion, 'DB Pricing Version', 'Label for DB pricing version');
    register.add(Id.v6, 'V6', 'Label for V6');
    register.add(Id.api, 'API', 'Label for API');
    register.add(Id.location, 'Location', 'Label for location');
    register.add(Id.dealerBuild, 'Dealer Build', 'Label for dealer build');
    register.add(Id.frameConfig, 'Frame Config', 'Label for frame config');
    register.add(Id.supplierDetails, 'Supplier Details', 'Label for supplier details section');
    register.add(Id.copiedToClipboard, 'Copied to clipboard', 'Dialog title for copied to clipboard');
    register.add(
      Id.versionDetailsCopied,
      'Version Details have been copied to the clipboard',
      'Toast for version details copied'
    );
    register.add(Id.build, 'Build', 'Label for build');
    register.add(
      Id.supplierSupportConnected,
      '{{glossary \'Supplier\'}} Support Connected to "{{tenantName}}"',
      'Support connected message'
    );
    register.add(Id.testingConnection, 'Testing connection every 5 minutes.', 'Supplier connection test message');
    register.add(
      Id.testingConnectionLastCheck,
      'Testing connection every 5 minutes. Last Check {{time}}',
      'Supplier connection test message with last check time'
    );
    register.add(Id.branchPlural, "{{glossary 'branch:plural'}}", 'Label for branches');
    register.add(
      Id.branchHidden,
      'Deactivated',
      'Suffix shown next to a deactivated branch name in the branch switcher (Cyncly Staff and supplier agents, who can view hidden branches)'
    );
    register.add(
      Id.restartV6Service,
      'Restart V6 Service "{{description}}"',
      'Menu item to restart V6 service for a supplier'
    );
  }
}
